import { COLOR, Icon as _Icon } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const MenuIcon = styled(_Icon)<{ isVisible: boolean }>`
  ${({ isVisible }) => isVisible && `background-color: ${COLOR.GRAY200.code};`}
  align-items: center;
  height: 100%;
  width: 44px;
  min-width: 44px;

  svg {
    height: 32px;
    width: 32px;
    margin: 0 auto;
  }
`;
